const ConfidentialityPoliticsPageElement = ({ type = "section2",
    title = "Un titre",
    texts = ["Premier pagagraphe", "Second paragraphe", "Troisème paragraphe"] }) => {

    const h2Css = `font-bold text-2xl text-darkRed my-4 global-px`

    const textsArrayFunc = () => {
        if (type === "section1") {
            return texts.map((text, i) => <p key={i}>{text}</p>).filter(Boolean)
        } else if (type === "section2") {
            return texts.map((text, i) => <div key={i}>
                <h3 className="font-bold my-2">{text[0]}</h3>
                {
                    text.map((pTxt, j) => j >= 1 && <p key={j}>&nbsp;{pTxt}</p>)
                }
            </div>).filter(Boolean)
        } else {
            return <p>&nbsp;{texts[1]}</p>
        }
    }
    const textsArray = textsArrayFunc()

    let element = null
    if (type === "intro") {
        element = <>
            <h1 className="text-center text-darkRed text-3xl font-bold mt-8 mb-4 lg:text-4xl">
                {title}
            </h1>
            <p className="font-bold">
                &nbsp;{texts}
            </p>
        </>
    } else if (type === "section1") {
        element = <>
            <section className="">
                <h2 className={h2Css}>{title}</h2>
                {textsArray}
            </section>
        </>
    } else {
        element = <>
            <section>
                <h2 className={h2Css}>{title}</h2>
                {textsArray}
            </section>
        </>
    }

    return (<>
        {element}
    </>
    )
}

export default ConfidentialityPoliticsPageElement